module.exports = __webpack_public_path__ + "img/symbol_9.c7849182.png";